<template>
  <div>
    <pv-data-info-box v-for="item in itemList" :key="item.index+item.id" :to="`/datasetseries/${item.id}?locale=${locale}`"
        scope="Dataset series"
        :origin="item.catalog?.country?.label"
        :src="getImg(getCatalogImage(item.catalog))"
        :dataset="{
          title:
            getTranslationFor(item.title, locale, item.catalog?.languages) || item.id,
          description: getTranslationFor(
            item.description,
            locale,
            item.catalog?.languages
          ),
          catalog: getTranslationFor(item.catalog?.title, locale, []),
          createdDate: null,
          updatedDate: null,
          formats: !item.format
            ? []
            : removeDuplicatesOf(item.format).filter(
                (format) => format.id || format.label
              ),
        }"
        :description-max-length="1000"
        :data-cy="`datasetseries@${item.id}`"
        class="mt-3" />
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {helpers} from "@piveau/piveau-hub-ui-modules";
import {groupBy, has, toPairs, uniqBy} from "lodash-es";

const { getImg, getTranslationFor, truncate } = helpers;

export default {
  name: "DatasetseriesList",
  computed: {
    ...mapGetters("search", ["getDatasetseriesItems"]),
    locale() {
      return this.$route.query.locale;
    },
    itemList() {
      return this.getDatasetseriesItems;
    }
  },
  props: {
    dssId: {
      type: String,
      default: null
    }
  },
  methods: {
    getImg,
    getTranslationFor,
    truncate,
    getCatalogImage(catalog) {
      return this.$env.content.catalogs.useCatalogCountries
        ? `${this.$env.content.catalogs.defaultCatalogImagePath}/${has(catalog, "country.id")
          ? catalog.country.id
          : this.$env.content.catalogs.defaultCatalogCountryID
        }`
        : `${this.$env.content.catalogs.defaultCatalogImagePath}/${has(catalog, "id")
          ? catalog.id
          : this.$env.content.catalogs.defaultCatalogID
        }`;
    },
    /**
     * @description Removes the duplicates of the given array
     * @param array {Array} - The array to remove duplicates from
     * @returns {Array}
     */
    removeDuplicatesOf(array) {
      const formatArray = Array.isArray(array)
        ? array
        : array && typeof array === 'object'
        ? [array]
        : [];
      const correctedFormatArray = formatArray
        .filter((format) => !!format)
        .map((format) => ({
          ...format,
          id: this.getBadgeFormat(format.id),
          label: this.getBadgeFormat(format.label),
        }));
      // sorts after # of occurences (highest occurence first)
      // possibility #1
      const sortedArray = toPairs(groupBy(correctedFormatArray, "id")).sort(
        (a, b) => b[1].length - a[1].length
      );
      const onlyFormatObjectsArray = sortedArray.map((arr) => arr[1][0]);
      // lodash uniqBy funtion removes duplicate id´s from array of objects
      const uniqById = uniqBy(onlyFormatObjectsArray, "id");
      return uniqBy(uniqById, "label");
    },
    /**
     * @description Cuts badge format string (max 8 chars)
     * @param label {String} - badge label or id (e.g. csv)
     */
    getBadgeFormat(label) {
      return this.truncate(label, 8, true);
    }
  }
}
</script>
